import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../context/AuthContext'; // Asegúrate de que este archivo esté DENTRO de src/
import { Grid, Card, Typography, TextField, Box, Autocomplete } from '@mui/material';
import { MainLayout } from "../layout/MainLayout";

import { ComentariosClientes } from "../components/ComentariosElementos/ComentariosClientes";
// Corregido: Importación según el nombre real del archivo (Customer o Costumer)
import { CustomerDocuments } from "../components/Private/CostumerDocuments";
import { getClientes, getOfertas } from "../api";
import { ComentariosPrivados } from "../components/ComentariosPrivados/ComentariosPrivados";

export const ComentariosPage = () => {
    const { user } = useContext(AuthContext);

    // ESTADOS
    const [clientes, setClientes] = useState([]);
    const [clienteSeleccionado, setClienteSeleccionado] = useState(null);

    const [ofertas, setOfertas] = useState([]);
    const [ofertasFiltradas, setOfertasFiltradas] = useState([]);
    const [filterOferta, setFilterOferta] = useState(null);

    const [inputNombreCliente, setInputNombreCliente] = useState("");

    useEffect(() => {
        const cargarDatos = async () => {
            try {
                const [respClientes, respOfertas] = await Promise.all([
                    getClientes(),
                    getOfertas()
                ]);

                const listaC = Array.isArray(respClientes) ? respClientes : (respClientes.data || []);
                const listaO = Array.isArray(respOfertas) ? respOfertas : (respOfertas.data || []);

                const clientesActivos = listaC.filter(c => !c.deleted);
                const ofertasActivas = listaO.filter(o => !o.deleted);

                setClientes(clientesActivos);
                setOfertas(ofertasActivas);
                setOfertasFiltradas(ofertasActivas);
            } catch (err) {
                console.error("Error cargando datos iniciales", err);
            }
        };

        cargarDatos();
    }, []);

    useEffect(() => {
        if (clienteSeleccionado) {
            const filtradas = ofertas.filter(ofertas => ofertas.codigoCliente === clienteSeleccionado.codigo);
            setOfertasFiltradas(filtradas);
        } else {
            setOfertasFiltradas(ofertas);
        }
    }, [clienteSeleccionado, ofertas]);


    const handleSelectCliente = (cliente) => {
        setClienteSeleccionado(cliente);
        if (filterOferta && filterOferta.codigoCliente !== cliente?.codigo) {
            setFilterOferta(null);
        }
    };

    const handleSelectOferta = (oferta) => {
        setFilterOferta(oferta);

        if (oferta) {

            const clienteRelacionado = clientes.find(c => c.codigo === oferta.codigoCliente);
            if (clienteRelacionado) {
                setClienteSeleccionado(clienteRelacionado);
            }
        }
    };
    return (
        <MainLayout title='Comentarios'>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant='h6' sx={{ fontWeight: 'bold' }}>
                            Gestión de Comentarios y Documentación
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 2, width: '60%', justifyContent: 'flex-end' }}>
                            <Autocomplete
                                sx={{ width: '45%' }}
                                options={clientes}
                                getOptionLabel={(option) => option.razonSocial || ""}
                                isOptionEqualToValue={(option, value) => option.id === value?.id}
                                value={clienteSeleccionado}
                                onChange={(event, newValue) => {
                                    setClienteSeleccionado(newValue);
                                    if (filterOferta && newValue && filterOferta.codigoCliente !== newValue.codigo) {
                                        setFilterOferta(null);
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Seleccionar Cliente" variant="outlined" />
                                )}
                            />
                            <Autocomplete
                                sx={{ width: '45%' }}
                                options={ofertasFiltradas}
                                // MODIFICADO: Ahora concatena numeroOferta
                                getOptionLabel={(option) => {
                                    if (!option) return "";
                                    return option.numeroOferta.toString();
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value?.id}
                                value={filterOferta}
                                onChange={(event, newValue) => {
                                    setFilterOferta(newValue);
                                    if (newValue && newValue.codigoCliente) {
                                        const clienteAsociado = clientes.find(c => c.codigo === newValue.codigoCliente);
                                        if (clienteAsociado) {
                                            setClienteSeleccionado(clienteAsociado);
                                        }
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Oferta" variant="outlined" />
                                )}
                            />
                        </Box>
                    </Card>
                </Grid>

                <Grid item xs={6}>
                    <Card sx={{ p: 2, height: '700px', display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="h6" color="primary">Comentarios</Typography>
                        <Box sx={{ flexGrow: 1, overflowY: 'auto', mt: 1 }}>
                            <ComentariosPrivados
                                oferta={filterOferta?.numeroOferta || 0}
                                idAnalisis={1}
                                nombreAnalisis={'Privado'}>
                            </ComentariosPrivados>
                        </Box>
                    </Card>
                </Grid>

                <Grid item xs={6}>
                    <Card sx={{ p: 2, height: '700px', display: 'flex', flexDirection: 'column' }}>
                        <Typography variant="h6" color="primary">Documentación Privada</Typography>
                        <Box sx={{ flexGrow: 1, mt: 1 }}>
                            <CustomerDocuments
                                user={user}
                                oferta={filterOferta}
                                clienteSeleccionado={clienteSeleccionado}
                            />
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </MainLayout >
    );
};